import { isEmptyArray, rebuildProducts } from '../../utilities';
import { get } from '../request';

const path = require('../../urls.json');

export async function getAllErpProducts () {
  try {
    const url = `${path.REACT_APP_UNSPLASH_URLSERVER}allProducts`;

    const res = await get(url);

    if (res !== false && !isEmptyArray(res.data)) {
      const rebuiltProducts = rebuildProducts(res.data);

      return rebuiltProducts;
    }

    return [];
  } catch (err) {
    return [];
  }
}
